import styled, { css } from 'styled-components';
import { DeprecatedIcon as Icon } from '@aon-coverwallet/cw-react-components';
import { TrackedLink } from '../trackedLink';

export const StyledHeaderActions = styled.div(
  ({ backgroundColor, theme: { colors } }) => css`
    position: relative;
    min-width: 200px;
    height: 60px;
    color: ${colors.white};
    background: ${backgroundColor
      ? backgroundColor
      : colors.brand.primary.default};
    border-left: 1px solid ${colors.gray.light};
    cursor: pointer;

    &:hover {
      background: ${colors.brand.primary.dark};
    }
  `,
);

export const StyledContainer = styled.div`
  height: 60px;
`;

export const StyledHeaderActionsTitle = styled.div(
  ({ primary, secondary, single }) => css`
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    padding: 0 34px 0 15px;
    font-weight: 400;

    ${primary &&
    css`
      padding-top: 7px;
      font-size: 15px;
      line-height: 22px;
    `}

    ${secondary &&
    css`
      position: relative;
      margin-bottom: 11px;
      font-size: 13px;
      line-height: 20px;
    `}

    ${single &&
    css`
      padding-top: 18px;
    `}
  `,
);

export const StyledHeaderDropdownIcon = styled.div`
  content: '';
  position: absolute;
  right: 12px;
  bottom: 28px;
  display: block;
  width: 9px;
  height: 9px;
  border-right: 1px solid ${({ theme: { colors } }) => colors.white};
  border-bottom: 1px solid ${({ theme: { colors } }) => colors.white};
  transform: rotate(45deg);
`;

export const StyledHeaderActionsItem = styled(TrackedLink)(
  ({ theme: { colors } }) => css`
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 50px;
    padding: 3px 10px;
    font-size: 13px;
    font-weight: 100;
    color: ${colors.gray.normal};
    border-top: 1px solid ${colors.gray.extraLight};
    transition: color 400ms, background-color 400ms;

    &:hover {
        background: #8eccf1;
        color: ${colors.white};
      }
    }
  `,
);

export const StyledHeaderActionItemContent = styled.div`
  display: flex;
`;

export const StyledIconAction = styled(Icon)(
  ({ theme: { colors } }) => css`
    height: 13px;
    margin: 3px 7px 0 0;

    path:first-of-type {
      fill: ${colors.gray.normal}};
    }
  `,
);

export const StyledHeaderActionsItemLabel = styled.div(
  ({ light }) => css`
    padding: 0;
    line-height: 18px;

    ${
      light &&
      css`
        font-weight: 100;
      `
    }
    }
  `,
);

export const StyledHeaderActionsItemsContainer = styled.div(
  ({ hidden, theme: { colors } }) => css`
    background: ${colors.white};
    box-shadow: 0 2px 1px 1px rgba(0, 0, 0, 0.1);
    ${
      hidden &&
      css`
        display: none;
      `
    }
    }
  `,
);

export const StyledHeaderActionsOnlyTitle = styled.div`
  font-size: 16px;
  line-height: 26px;
  padding-top: 16px;
  padding-left: 20px;
`;

export const StyledHeaderActionsEmptySubtitle = styled.div`
  &:after {
    bottom: 11px;
  }
`;
